/**
 * Section ids match `id` on topic title divs in Explore User Guide content
 * (see ExploreUserGuide/*.js) and nav `name` in UserGuideModal.
 */
export const USER_GUIDE_SECTION_ANALYZING_COHORTS = 'Cohort Analyzer';
